@if (notificationService.notificationBarMessages$ | async; as alertMsgs) {
  @if (alertMsgs?.length > 0) {
    <div class="alert-bar">
      @for (msg of alertMsgs; track msg; let i = $index) {
        <div class="alert-bar__message" [ngClass]="msg.severity">
          <svg-icon key="warning-triangle" />
          <p [innerHTML]="msg.htmlText"></p>
          @if (msg.contactSupportEnabled) {
            <button type="button" (click)="openContactSupportModal()" class="btn btn-link">Contact support</button>
          }
          @if (msg.link) {
            <a [routerLink]="msg.link.route" [queryParams]="msg.link.queryParams" class="btn btn-link">{{ msg.link.text }}</a>
          }
        </div>
      }
    </div>
  }
}
